export default __webpack_public_path__ + "static/media/brady-logo-white.8617c43c.svg";